import {
  IDurationInput,
  IPartitionInput,
  IPartitionValueFieldsFragment,
  TimeUnit,
} from '../../../utils/apollo/graphqlSchema';
import { isNil } from 'lodash';
import { MaybeNil } from '../../../utils/interfaces';
import { getCapitalizedTimeUnitText } from '../../../utils';

export const conversionWindowTimeUnitToText = (
  timeUnit: TimeUnit,
  n?: number | null,
) => {
  const timeUnitText = getCapitalizedTimeUnitText(timeUnit);
  return isNil(n) || isNaN(n) || n !== 1
    ? timeUnitText.plural
    : timeUnitText.singular;
};

export const partitionValuesToInput = (
  partitions: IPartitionValueFieldsFragment[],
): IPartitionInput[] => {
  return partitions.map((pv) => {
    const cw = pv.conversionWindow;
    const conversionWindowInput: MaybeNil<IDurationInput> = cw
      ? {
          value: cw.value,
          timeUnit: cw.timeUnit,
        }
      : null;
    return {
      partition: pv.partition.key,
      conversionWindowInput,
    };
  });
};
